import React, { createContext, useContext } from 'react';
import { useError } from '@/hooks';

interface ErrorContextType {
  globalError: ReturnType<typeof useError>;
}

const ErrorContext = createContext<ErrorContextType | null>(null);

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const globalError = useError();

  return (
    <ErrorContext.Provider
      value={{
        globalError,
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorContext must be used within an ErrorProvider');
  }
  return context;
};
